import React from "react";
import { useAuth } from "@/context/AuthContext";
import { getRoleTheme } from "@/lib/roleTheme";

// Reusable badge that shows current role with its accent color
export default function RoleBadge({ size = "sm", showLabel = true, withIcon = true }) {
  const { user } = useAuth();
  if (!user?.role) return null;
  const t = getRoleTheme(user.role);
  const Icon = t.icon;
  const padding = size === "lg" ? "px-3 py-1.5 text-[11px]" : "px-2 py-1 text-[10px]";
  return (
    <span
      data-testid={`role-badge-${user.role}`}
      style={{ backgroundColor: t.badgeBg, color: t.badgeText, borderColor: t.badgeBorder }}
      className={`inline-flex items-center gap-1.5 border rounded-full font-bold uppercase tracking-[0.12em] ${padding}`}
    >
      {withIcon && <Icon size={size === "lg" ? 12 : 10} />}
      {showLabel && t.label}
    </span>
  );
}
